import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild
{
    /**
     * Constructor
     */
    constructor(
        private _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        if (localStorage.getItem('token')) {
            return true;
        } else {
            this._router.navigateByUrl('/user/sign-in');
            return false;
        }
        // const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        // return this._check(redirectUrl);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        if (localStorage.getItem('token')) {
            return true;
        } else {
            this._router.navigateByUrl('/user/sign-in');
            return false;
        }
        // const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        // return this._check(redirectUrl);
    }

}
